import { RegistreringContextType } from "./Registreringsflyt";
import { useOutletContext } from "react-router";

export function useRegistreringContext() {
  return useOutletContext<RegistreringContextType>();
}
